import { getUsersMenuItems } from './admin/users';
import { getBaseMenuItems } from './BaseMenuItems';
// import { getOtherRouteItems } from './OtherMenuItems';
import { getBorrowersMenuItems } from './admin/borrowers';
import { getInvestorsMenuItems } from './admin/investors';
// import { getSettingsMenuItems } from './admin/settings';
import { getFacilitatorsMenuItems } from './admin/facilitators';

export const getAdminMenuItems = (basePath, toggleCollapsed, topMenu) => {
  return [
    ...getBaseMenuItems(basePath, toggleCollapsed, topMenu),
    ...getUsersMenuItems(basePath, toggleCollapsed, topMenu),
    ...getBorrowersMenuItems(basePath, toggleCollapsed, topMenu),
    ...getInvestorsMenuItems(basePath, toggleCollapsed, topMenu),
    ...getFacilitatorsMenuItems(basePath, toggleCollapsed, topMenu),
    // ...getSettingsMenuItems(basePath, toggleCollapsed, topMenu),
    // ...getOtherRouteItems(basePath, toggleCollapsed, topMenu),
  ];
};
